import { ReduxAction } from '../../types/reducers'
import { UserInfo } from '../../types/user'

export enum USER_ACTIONS {
    SET_USER_DATA = 'userActions/setUserData',
    SET_USER_AUTH_TOKEN = 'userActions/setUserToken',
    LOGOUT_USER = 'userActions/logoutUser',
}

export const setLoggedUserData: ReduxAction<UserInfo, USER_ACTIONS> = (user: UserInfo) => {
    return {
        type: USER_ACTIONS.SET_USER_DATA,
        payload: user,
    }
}

export const setLoggedUserAuthToken: ReduxAction<string, USER_ACTIONS> = (authToken: string) => {
    return {
        type: USER_ACTIONS.SET_USER_AUTH_TOKEN,
        payload: authToken,
    }
}

export const logoutUser = () => {
    return {
        type: USER_ACTIONS.LOGOUT_USER,
    }
}
